import * as React from 'react';
import { cn } from '@/lib/cn';

export type InputProps = React.InputHTMLAttributes<HTMLInputElement>;

export const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type = 'text', ...props }, ref) => {
    return (
      <input
        ref={ref}
        type={type}
        className={cn(
          'flex h-11 w-full rounded-[var(--radius-md)] border border-[color:var(--color-border)] bg-[color:var(--color-surface)] px-3 text-sm text-[color:var(--color-fg)] shadow-sm',
          'placeholder:text-[color:var(--color-fg-subtle)]',
          'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[color:var(--color-accent)] focus-visible:ring-offset-2 focus-visible:ring-offset-[color:var(--color-bg)]',
          'disabled:cursor-not-allowed disabled:opacity-50',
          'aria-[invalid=true]:border-[color:var(--color-danger)] aria-[invalid=true]:ring-[color:var(--color-danger)]',
          className
        )}
        {...props}
      />
    );
  }
);
Input.displayName = 'Input';
